import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'

const SecondPage = () => (
  <Layout>
    <h1>Photos</h1>
    <section className="photo">
      <p>
        <img
          className="djmblog_image"
          id="McKeown Family at Yellowstone National Park, 2007"
          src="https://djmblog.com/assets/files/McKeowns-Yellowstone-2007.jpg"
          alt="McKeown Family at Yellowstone National Park, 2007"
        />
      </p>
      <span className="photoLabel">Yellowstone, 2007</span>
    </section>
    <section className="photo">
      <p>
        <img
          className="djmblog_image"
          id="McKeown Family in Des Plaines, Illinois, 2009"
          src="https://djmblog.com/assets/files/McKeowns-Illinois-2009.jpg"
          alt="McKeown Family in Des Plaines, Illinois, 2009"
        />
      </p>
      <span className="photoLabel">Illinois, 2009</span>
    </section>
    <style jsx>{`
      section.photo {
        margin-bottom: calc(10px + 4vh);
        background: lightblue;
      }  
    `}</style>
  </Layout>
)

export default SecondPage
